import { newApi } from '@/Plugins/Axios'
import Rest from '../rest'

/******************************************************************************
 *  Products
 *****************************************************************************/

/**
 * @type {Product}
 */
export default class Product extends Rest {
    constructor() {
        super('/products')
		this.http = newApi
    }

	get(id){
		return this.http.get(`/propertys`, {
			params: {
				search: `id:${id}`,
				searchFields: 'id:=',
				searchJoin: 'and',
				with: 'cover;types.item;types.subitem;availability;gallerys.gallery.categories.categoriesfiles.file;field_value;gallerys;items'
			}
		})
	}
}
